import { FC, forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'antd';
import styles from './index.module.less';

import { useMethods } from '@lhb/hook';
import IconFont from '@/common/components/IconFont';
import { replaceEmpty } from '@lhb/func';
import dayjs from 'dayjs';
import PracticeDetailFDrawer from '@/common/components/business/PracticeDetailFDrawer';
import AddForm from './AddForm';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

/**
 * 新增打靶任务弹窗
 * @description
 * @demo
 */
const CheckList:FC<{
  targetPunchInAlias:string,
  onRefresh: Function,
  onContinueCheckIn: Function,
  ref?: any
}> = forwardRef(({ targetPunchInAlias, onRefresh, onContinueCheckIn }, ref) => {
  useImperativeHandle(ref, () => ({
    init: methods.init,
    refresh: methods.refresh,
  }));

  /* state */
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [addFormOpen, setAddFormOpen] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [detailDrawerData, setDetailDrawerData] = useState<any>({ // 踩点记录详情弹窗
    open: false,
    id: null,
    isEdit: false
  });
  const [addressInfo, setAddressInfo] = useState<any>({});
  /* methods */
  const methods = useMethods({

    init(data: any = []) {
      setIsOpen(true);
      setData(data);
    },
    refresh(data: any = []) {
      setData(data);
    },
    async onOk() {
      const addressInfo = await onContinueCheckIn();
      if (!addressInfo) {
        V2Message.error('附近暂无poi，请重试');
        return;
      };
      setAddressInfo(addressInfo);
      setAddFormOpen(true);
      // onContinueCheckIn();
    },

    onCancel() {
      setIsOpen(false);
    },
    renderAddress(data: any) {
      const addressList = [data?.provinceName, data?.cityName, data?.districtName, data?.address];

      return addressList.filter(item => item).join('');
    },
    handlePositionName(record: any) {
      setDetailDrawerData({ open: true, id: record.id });
    },
    onAddClose(shouldRefresh = false) {
      setAddFormOpen(false);
      shouldRefresh && onRefresh();
      shouldRefresh && methods.onCancel();
    }
  });

  return (<div>
    <Modal
      title={ '提示'}
      open={isOpen}
      width={640}
      wrapClassName={styles.checkListModal}
      onCancel={methods.onCancel}
      onOk={methods.onOk}
      okText='继续新增任务'
    >
      <div className={styles.tips}>
        <IconFont iconHref='pc-common-icon-ic_warning'/>
        <span>您所选的位置300m范围内已有打卡任务</span>
      </div>
      <div className={styles.checkList}>
        {!!data.length && data.map(itm => <div className={styles.row} key={itm.id} onClick={() => methods.handlePositionName(itm)}>
          <div className={styles.leftRow}>
            <img
              src='https://staticres.linhuiba.com/project-custom/locationpc/flow/fixed_point2.png'
            />
          </div>
          <div className={styles.right}>
            <div className={styles.rightTop}>
              <div className={styles.title}>{methods.renderAddress(itm)}</div>
              <div className={styles.tag}>
                {itm?.lastCheckDateTime && dayjs(itm.lastCheckDateTime).isValid() ? <div className={styles.checkIn}>{dayjs(itm.lastCheckDateTime).format('YYYY.MM.DD')}已打卡</div> : <div className={styles.noCheckIn}>未打卡</div>}
              </div>
            </div>
            <div className={styles.rightBtm}>
              打卡要求：{replaceEmpty(itm?.requirement)}
            </div>
          </div>
        </div>)}
      </div>
    </Modal>
    <PracticeDetailFDrawer
      drawerData={detailDrawerData}
      targetPunchInAlias={targetPunchInAlias}
      setDrawerData={setDetailDrawerData}
      handleClose={() => setDetailDrawerData({
        id: '',
        open: false,
        isEdit: false
      })}
      onRefresh={() => onRefresh?.(true)}
    />
    <Modal
      open={addFormOpen}
      footer={null}
      width={336}
      className={styles.addFormModal}
      destroyOnClose
    >
      <AddForm
        addressInfo={addressInfo}
        onClose={methods.onAddClose}
        targetPunchInAlias={targetPunchInAlias}
      />
    </Modal>
  </div>);
});

export default CheckList;
